import { RootState } from '../../reducers'
import { endpointHelpers } from './endpointHelpers'

const latestVersionFlowResponseSelector =
  endpointHelpers.getOriginalVersionFlowForCurrentBot.select()

export const latestVersionFlowSelector = (state: RootState) => {
  return latestVersionFlowResponseSelector(state)?.data
}

export const isOriginalVersionFlowLoadingSelector = (state: RootState) => {
  return latestVersionFlowResponseSelector(state)?.isLoading
}

export const originalVersionFlowFetchErrorSelector = (state: RootState) => {
  return latestVersionFlowResponseSelector(state)?.error
}
